<template>
	<eui-panel
		:vp-inaktiverad="skaVaraInaktiverad"
		:disabled="skaVaraInaktiverad"
		:vp-osynlig="skaVaraOsynlig"
		:class="{
			'-osynlig':skaVaraOsynlig
		}"

		:vp-visa-menyfaltet="vpArIRedigeralage"
		:vp-meny-config.sync="menyConfig"

		style="width: 100%; height: 100%;"

		@menyalternativ-valt-i-panel="onMenyalternativValtIPanel"
	>
		<template #huvudtext>
			<span class="ellipsis">Konto {{ vpWidgetData.accountid }} – {{ vpWidgetData.accountname }}</span>
			<!--<span v-if="vpArIRedigeralage" @click="onDeleteWidget" style="float: right; cursor:pointer;">X</span>-->
		</template>

		<!-- Kroppen (default slot): -->
		<div>
			<a class="bildlank" tabindex="-1" :href='"/kontoutdrag/" + vpWidgetData.accountid'>
				<p class="somh1" style="color: lightseagreen;">Utgående balans {{ vpWidgetData.closingbalance }}</p>
			</a>
		</div>
	</eui-panel>
</template>


<script>
// ################################################################################################################

	import euiPanel from 'v-components/euiPanel';
	import { ssoGeneriskWidgetMixin } from 'v-mixins/ssoGeneriskWidgetMixin';

	export default {
		name: 'kontoutdragwidget',

		// All generisk widgetfunktionalitet, se 'ssoGeneriskWidgetMixin.js'.
		mixins: [ssoGeneriskWidgetMixin],

		// Lokalt registrarade komponenter
		components: {
			[euiPanel.name]: euiPanel,
		},

		//// Props utöver de från mixin ovan:
		//props: {
		//},


		//== Lifecycle hooks  ================================================================================================================

	}
</script>

